import * as React from "react";
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { BDKalkCore } from "./BDKalkCore"
import { BuildPartQRItem } from "./BuildPartQRItem"

interface ChoiseControlVm {
    core: BDKalkCore,
    buildPartQRItem: BuildPartQRItem
}

interface ChoiseControlStates {
    hovering: boolean,
    minusPressed: boolean,
    plusPressed: boolean,
    crossPressed: boolean
}

/*  ChoiseControlBuildPart is the amount controlling device shown on each quick report BuildPart item's left side,
 *  with plus and minus buttons and a text field in the middle where a new amount can be typed in.
 *  These are made specific for either the BuildPart view or the quick report view with some differences,
 *  mainly that items within the quick report also have a cross button for removing the BuildPart out of the list,
 *  unlike the ChoiseControlGW class for the BuildPart view items.  */
export class ChoiseControlBuildPartQR extends React.Component<ChoiseControlVm, ChoiseControlStates> {
    constructor(props: ChoiseControlVm) {
        super(props)
    }

    // Sets the reference to this control within the BuildPart item on initiation
    componentWillMount() {
        this.props.buildPartQRItem.ConnectQRChoise(this)
    }

    /* This is called by react soon after creation and before this component is rendered, and it may
     * result in focus being set to the input area  */
    componentDidMount() {
        if (this.state.inputActive == true) {
            this.textInput.focus()
        }
    }

    state = {
        hovering: false,
        minusPressed: false,
        plusPressed: false,
        crossPressed: false,
        inputActive: false
    }

    m_holder: BuildPartQRItem
    m_begunTyping: boolean
    
    textInput: HTMLInputElement  // A handle to the input object

    // Handler for the clicks on the minus button, which are passed on to a handler within BDKalkCore
    MinusClick() {
        this.props.buildPartQRItem.SetLocation("minus")
    }

    // Handler for the minus button being pressed (which will change its graphics)
    MinusDown() {
        this.setState({ minusPressed:true })
    }

    // Handler for the minus button being released (which will change its graphics)
    MinusUp() {
        this.setState({ minusPressed: false })
    }

    // Handler for the plus button being pressed (which will change its graphics)
    PlusDown() {
        this.setState({ plusPressed: true })
    }

    // Handler for the plus button being released (which will change its graphics)
    PlusUp() {
        this.setState({ plusPressed: false })
    }

    // Handler for the clicks on the plus button, which are passed on to a handler within BDKalkCore
    PlusClick() {
        this.props.buildPartQRItem.SetLocation("plus")
    }

    // Handler for the clicks on the close button, which are passed on to a handler within BDKalkCore
    CloseClick() {
        this.props.buildPartQRItem.SetLocation("cross")
    }

    // Handler for the close button being released (which will change its graphics)
    CloseUp() {
        this.setState({ crossPressed: false })
    }

    // Handler for the close button being pressed (which will change its graphics)
    CloseDown() {
        this.setState({ crossPressed: true })
    }

    // Handler for when the central area gets clicked (will change the control into typing mode)
    CenterClick() {
        this.props.buildPartQRItem.SetLocation("input")
    }
    
    // Handler for when the mouse leaves the numeric control (may affect the graphics of the control)
    MouseOut() {
        if (this.props.buildPartQRItem.GetInputActive() == false) {
            this.setState({ minusPressed: false, plusPressed: false })
        }
        else {
            this.textInput.click()
        }
    }

    // Gives a warning if a given input is not a valid number
    handleBadInput() {
        if (this.textInput.value.length > 0) {
            alert("You have entered an invalid value, please type in a number")
        }
    }

    // Checks if the input is a valid number and enters it if so, or calls handleBadInput()
    processInput() {
        var tested = this.props.core.GetApp().ParseToPositiveNumber(this.textInput.value)

        if (tested == null) {
            this.handleBadInput()
            return
        }
        
        /* The number has been concidered valid and will be entered as 
           a new amount for the article */

        setTimeout(this.props.core.RedrawTotalSum.bind(this.props.core), 40)
        
        this.props.buildPartQRItem.SetAmount(tested)
        this.props.core.ClearInput(0)
        this.props.buildPartQRItem.forceUpdate()

    }

    // Handler for keydown events
    onKeyDown(key: string) {

        if ((key == "0") || (key == "1") || (key == "2") || (key == "3") || (key == "4") || (key == "5") || (key == "6") || (key == "7") || (key == "8") || (key == "9")) {
            if (this.m_begunTyping == false) {
                this.m_begunTyping = true
                this.forceUpdate()
            }
            return
        }

        if ((key == ".") || (key == ",")) {
            if (this.m_begunTyping == false) {
                this.m_begunTyping = true
                this.forceUpdate()
            }
            return
        }

        if ((key == "Backspace") || (key == "Delete")) {
            if (this.m_begunTyping == false) {
                this.m_begunTyping = true
                this.forceUpdate()
            }
            return
        }

        if ((key == "ArrowLeft") || (key == "ArrowRight")) {
            return
        }

        if ((key == "ArrowUp") || (key == "ArrowDown")) {
            return
        }

        if ((key == "Enter") || (key == "Tab")) {
            this.processInput()
            return
        }

        if (key == "Control") {
            return
        }
        
        alert("Only use numeric keys please! (you entered: \"" + key + "\")")

        return
    }

    isHovered() {
        if (this.props.buildPartQRItem.GetIsHovered() == true) {
            return true
        }

        return false
    }
    
    render() {
        var amount = "(no amount)"

        if (this.props.buildPartQRItem.props.buildPart.GetAmount() != -1) {
            var amount = this.props.core.GetApp().GetRoundedNumericString(this.props.buildPartQRItem.props.buildPart.GetAmount())
        }
                
        // Hovering or selecting the item that owns this numeric control will have effect on its graphics
        if (this.isHovered() || (this.props.buildPartQRItem.isSelected() == true)) {
            // the item is either selected or hovered by the mouse
            if (this.props.buildPartQRItem.GetInputActive()) {
                this.props.core.GetApp().ReFocus(300) // Calls a delayed focus to the input area

                // Grey amount is the value shown in ligth gray when input is active but nothing has been entered yet
                var greyAmount = amount
                if (this.m_begunTyping == true) {
                    greyAmount = ""
                }

                return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>
                    {/*   Close button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.crossPressed) ? "0px -150px" : "0px -90px",
                            width: "16px",
                            height: "29px"
                        }}
                        onClick={this.CloseClick.bind(this)}
                        onMouseDown={this.CloseDown.bind(this)}
                        onMouseUp={this.CloseUp.bind(this)}>
                    </div>
                    {/*   Minus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.minusPressed) ? "-16px -120px" : "-16px -90px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.MinusClick.bind(this)}
                        onMouseDown={this.MinusDown.bind(this)}
                        onMouseUp={this.MinusUp.bind(this)}>
                    </div>

                    {/*   Numeric input   */}
                    <div style={{
                        position: 'relative',
                        width: '47px',
                        height: '26px',
                        backgroundImage: "url(images/ChoisePanelCollection.png)"
                    }}>
                        <input
                            type="text"
                            ref={(input) => { if (input != null) this.textInput = input }}
                            id="inputToBeFocusedOn"
                            onKeyDown={(par) => { this.onKeyDown(par.key) }}
                            style={{
                                position: 'relative',
                                width: '45px',
                                height: '26px',
                                top: '0px',
                                left: '0px',
                                border: '0px',
                                backgroundImage: "url(images/ChoisePanelCollection.png)"
                            }}>
                        </input>
                        <div style={{
                            color: "#BBBBBB",
                            position: 'relative',
                            width: '45px',
                            height: '26px',
                            top: '-24px',
                            left: '4px',
                            border: '0px'
                        }}>{greyAmount}
                        </div>
                    </div>

                    {/*   Plus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.plusPressed) ? "0px -261px" : "0px -231px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.PlusClick.bind(this)}
                        onMouseDown={this.PlusDown.bind(this)}
                        onMouseUp={this.PlusUp.bind(this)}>
                    </div>
                </div>;
            }
            else {
                this.m_begunTyping = false
                return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>
                    {/*   Close button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.crossPressed) ? "0px -150px" : "0px -90px",
                            width: "16px",
                            height: "29px"
                        }}
                        onClick={this.CloseClick.bind(this)}
                        onMouseDown={this.CloseDown.bind(this)}
                        onMouseUp={this.CloseUp.bind(this)}>
                    </div>
                    {/*   Minus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.minusPressed) ? "-16px -120px" : "-16px -90px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.MinusClick.bind(this)}
                        onMouseDown={this.MinusDown.bind(this)}
                        onMouseUp={this.MinusUp.bind(this)}>
                    </div>
                    {/*   Central text - amount   */}
                    <div
                        style={{
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: "0px 0px",
                            cursor: "pointer",
                            minWidth: "39px",
                            padding: "4px"
                        }}
                        onClick={this.CenterClick.bind(this)}>{amount}
                    </div>
                    {/*   Plus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.plusPressed) ? "0px -261px" : "0px -231px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.PlusClick.bind(this)}
                        onMouseDown={this.PlusDown.bind(this)}
                        onMouseUp={this.PlusUp.bind(this)}>
                    </div>
                </div>;
            }
        }
        else { // THe item is not selected or being hovered by the mouse
            this.m_begunTyping = false
            return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>
                {/*   Close button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px -60px",
                        width: "16px",
                        height: "29px"
                    }}
                    onClick={this.CloseClick.bind(this)}>
                </div>
                {/*   Minus button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "-16px -60px",
                        width: "22px",
                        height: "29px"
                    }}
                    onClick={this.MinusClick.bind(this)}>
                </div>
                {/*   Central text - amount   */}
                <div
                    style={{
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px -30px",
                        cursor: "pointer",
                        minWidth: "39px",
                        padding: "4px"
                    }}
                    onClick={this.CenterClick.bind(this)}>{amount}
                </div>
                {/*   Plus button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px -201px",
                        width: "22px",
                        height: "29px"
                    }}
                    onClick={this.PlusClick.bind(this)}>
                </div>
            </div>;
        }
    }
}



// WEBPACK FOOTER //
// ./client/view/ChoiseControlBuildPartQR.tsx